'use client';

import { cn } from '../../lib/utils';

export type TLoaderProps = {
  className?: string;
  text?: string;
};

export function Loader({ className, text }: TLoaderProps) {
  return (
    <div className="flex items-center gap-2">
      <svg className={cn('h-5 w-5 animate-spin text-gray-500', className)} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
        <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
        <path
          className="opacity-75"
          fill="currentColor"
          d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
      </svg>
      {text && <span className={cn('font-semibold text-gray-500', className)}>{text}</span>}
    </div>
  );
}

export function PointsLoader() {
  return (
    <div className="flex items-center gap-2">
      <div className="h-2 w-2 animate-pulse rounded-full bg-gray-500"></div>
      <div className="h-2 w-2 animate-pulse rounded-full bg-gray-500 delay-100"></div>
      <div className="h-2 w-2 animate-pulse rounded-full bg-gray-500 delay-200"></div>
    </div>
  );
}
